module.exports = __webpack_public_path__ + "static/media/WilliamsburgBridgeA0039_bg_clean_v001.65bbff00.webp";